module.exports = __webpack_public_path__ + "img/edge_restauration_restaurant_etoile.2949d1f1.svg";